import { CANVAS_HEIGHT, CANVAS_WIDTH } from './types';

/**
 * Az ábra letöltése PNG-ként. Az SVG-t képpé alakítjuk, majd dupla felbontású
 * vásznon rajzoljuk újra, hogy nyomtatva és telefonon is éles legyen.
 */
export const downloadDiagramPng = async (svg: SVGSVGElement, fileName: string): Promise<void> => {
  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute('width', String(CANVAS_WIDTH));
  clone.setAttribute('height', String(CANVAS_HEIGHT));
  // A szerkesztő kijelölés-keretei ne kerüljenek a képre
  clone.querySelectorAll('[data-editor-overlay]').forEach((node) => node.remove());

  const markup = new XMLSerializer().serializeToString(clone);
  const url = URL.createObjectURL(new Blob([markup], { type: 'image/svg+xml;charset=utf-8' }));

  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Az ábrát nem sikerült képpé alakítani.'));
      img.src = url;
    });

    const scale = 2;
    const canvas = document.createElement('canvas');
    canvas.width = CANVAS_WIDTH * scale;
    canvas.height = CANVAS_HEIGHT * scale;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('A böngésző nem támogatja a képmentést.');
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new Error('A képmentés nem sikerült.');

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName.endsWith('.png') ? fileName : `${fileName}.png`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  } finally {
    URL.revokeObjectURL(url);
  }
};
